<template>
  <div
    id="app"
    class="min-h-screen font-sans antialiased text-gray-900 bg-gray-100"
  >
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {

  methods: {
    ...mapActions(['tryAutoLogin']),
  },

  created() {
    this.tryAutoLogin();
  },
};
</script>
